export enum PaymentType {
  WITHDRAW = 0,
  DEPOSIT_FROM_REFERRER = 1,
}
